import { useEffect, useState } from 'react'
import { trimImageWhitespace, type LogoTrimVariant } from '@/utils/trimImageWhitespace'

export function TrimmedLogo({
  src,
  alt = '',
  className,
  variant = 'sidebar',
}: {
  src: string
  alt?: string
  className?: string
  variant?: LogoTrimVariant
}) {
  const [out, setOut] = useState(src)

  useEffect(() => {
    let live = true
    setOut(src)
    void trimImageWhitespace(src, variant).then((next) => {
      if (live) setOut(next)
    })
    return () => {
      live = false
    }
  }, [src, variant])

  return <img src={out} alt={alt} className={className} />
}
